import { useEffect, useState } from "react";
import { FaCheck } from "react-icons/fa";
import { Collapse } from "reactstrap";

const CollapsibleUI = ({ children, isMain, category, setActiveCategory, activeCategory, subcategoryId }) => {

    const [isOpen, setIsOpen] = useState(false);


    const handleClick = (e) => {
        e.stopPropagation();
        setActiveCategory(category);
        setIsOpen(!isOpen);
    };
    // console.log(category);
    return (

        <div style={{ border: (activeCategory?.id === category.id) ? "2px solid green" : "2px solid transparent" }} className={`d-flex flex-column shadow mb-2 bg-white rounded`}>
            <div style={{ borderRaduis: 10 }} className={`rounded py-1 px-3 d-flex justify-content-around cursor-pointer bg-white}`} onClick={handleClick}>
                <div className="d-flex col-12 my-auto justify-content-between">
                    <p className={`my-auto text-dark ${isMain ? 'fw-bold' : ''}`}>{category.category_name ?? 'Title Here'}</p>
                    {(activeCategory?.id === category.id) &&
                        <div className="d-flex bg-success py-1 px-3 rounded">
                            {/* <p className="small my-auto me-2 fw-bold text-white">Selected</p> */}
                            <FaCheck className=" my-auto" color="#ffffff" />
                        </div>
                    }
                </div>
                {category.subcategory.length > 0 && <span className={`text-dark lead text-dark`}>{isOpen ? <span>&#x025B4;</span> : <span>&#x025BE;</span>}</span>}
            </div>
            {category.subcategory.length > 0 &&
                <Collapse isOpen={isOpen}>
                    <hr />
                    <div className="px-3">
                        {children}

                    </div>
                </Collapse>
            }
        </div >

    );
}

export default CollapsibleUI;